<template>
  <v-layout justify-center>
    <v-flex>
      <v-card ref="form">
        <v-card-text>
          <template v-for="(error, index) in errors">
            <v-alert color="error" :value= "hasError('non_field_errors')">
              {{getErrorArray('non_field_errors')}}
            </v-alert>
          </template>
          <v-autocomplete
            :error="hasError('prev')"
            :error-messages="getError('prev')"
            :items="selectors.prev"
            item-text="name"
            item-value="id"
            label="Образован из"
            multiple
            placeholder="Образован из"
            v-model="value.prev"
            no-data-text ="Нет данных"
          ></v-autocomplete>

          <v-text-field
            :error="hasError('name')"
            :error-messages="getError('name')"
            item-text="name"
            label="Статус"
            v-model="value.name"
          ></v-text-field>

          <v-layout>
            <v-checkbox
              :error="hasError('start')"
              :error-messages="getError('start')"
              label="Начальный статус"
              v-model="value.start"
            ></v-checkbox>
            <v-checkbox
              :error="hasError('require_motivation')"
              :error-messages="getError('require_motivation')"
              label="Пояснять изменение статуса"
              v-model="value.require_motivation"
            ></v-checkbox>
          </v-layout>
          <v-layout>
            <v-checkbox
              :error="hasError('allowed')"
              :error-messages="getError('allowed')"
              label="Признак принятия"
              v-model="value.allowed"
            ></v-checkbox>
            <v-checkbox
              :error="hasError('rejected')"
              :error-messages="getError('rejected')"
              label="Признак отказа"
              v-model="value.rejected"
            ></v-checkbox>
          </v-layout>

          <v-btn @click="apply" color="primary">Сохранить</v-btn>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import urls from "../urls"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import {makeManagerUrl, makeGetRequest} from "../../../helper";

  export default {
    name: "Status",
    mixins: [UserDataFormMixin],
    props: {
      id: Number,
      name: String,
      prev: Number,
      require_motivation: Boolean,
      start: Boolean,
      allowed: Boolean,
      rejected: Boolean
    },
    data() {
      return {
        URL_CREATE: (urls.getUrl('admin|petition|petition|status-list', 'create')),
        URL_UPDATE: (urls.getUrl('admin|petition|petition|status-detail', 'update')),

        selectors: {
          prev: [],
        },

        value: {
          id: this.id || '',
          name: this.name || '',
          prev: this.prev || [],
          require_motivation: this.require_motivation || false,
          start: this.start || false,
          allowed: this.allowed || false,
          rejected: this.rejected || false,
        },

      }
    },
    methods: {},
    created() {
      this.getChoices(
        makeManagerUrl(urls.getUrl('admin|petition|petition|status-list', 'list')),
      ).then(choices => {
        this.selectors.prev = choices
      });
      if(this.id !== ""){
        makeGetRequest(urls.getUrl('admin|petition|petition|status-detail', 'update').replace('<id>', this.id) ).then(
          resp => resp.json())
          .then(json => {
            this.value = json
          })
      }
    }
  }

</script>


<style scoped>

</style>
